import { HashRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import Loader from "./components/Loader/Loader";
import ToastContainer from "./components/toast";
import { privateRoutes, publicRoutes } from "./utils/routes";
import AdminLayout from "./Layout/AdminLayout";
import Layout from "./Layout/Layout";

function App() {
  return (
    <HashRouter>
      <Loader />
      <ToastContainer />
      <Routes>
        {publicRoutes?.map((route, index) => (
          <Route
            path={route?.path}
            key={index}
            element={<Layout Page={route?.page} />}
          />
        ))}
        {privateRoutes?.map((route, index) => (
          <Route
            path={route?.path}
            key={index}
            element={<AdminLayout Page={route?.page} />}
          />
        ))}
      </Routes>
    </HashRouter>
  );
}

export default App;
